import { render } from "./BooleanField.vue?vue&type=template&id=0a747d58"
import script from "./BooleanField.vue?vue&type=script&lang=js"
export * from "./BooleanField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BooleanField.vue"]])

export default __exports__